import React from 'react';
import { VStack, Button } from '@chakra-ui/react';
import { Field } from '@/components/ui/field';
import { PasswordInput } from '@/components/ui/password-input';

interface PasswordChangeContentProps {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
  onCurrentPasswordChange: (password: string) => void;
  onNewPasswordChange: (password: string) => void;
  onNewPasswordConfirmChange: (password: string) => void;
  onSubmit: () => void;
  isSamePassword: boolean;
  isPasswordMismatch: boolean;
  isFormValid: boolean;
  isLoading?: boolean;
}

export const PasswordChangeContent: React.FC<PasswordChangeContentProps> = ({
  currentPassword,
  newPassword,
  newPasswordConfirm,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onNewPasswordConfirmChange,
  onSubmit,
  isSamePassword,
  isPasswordMismatch,
  isFormValid,
  isLoading = false,
}) => {
  return (
    <VStack gap={6} align="stretch" pb={4}>
      <Field label="現在のパスワード" required>
        <PasswordInput
          placeholder="現在のパスワード"
          value={currentPassword}
          onChange={e => onCurrentPasswordChange(e.target.value)}
          size="lg"
        />
      </Field>

      <Field
        label="新しいパスワード"
        required
        invalid={isSamePassword || undefined}
        errorText={isSamePassword ? '現在のパスワードと同じです' : undefined}
      >
        <PasswordInput
          placeholder="新しいパスワード"
          value={newPassword}
          onChange={e => onNewPasswordChange(e.target.value)}
          size="lg"
        />
      </Field>

      <Field
        label="新しいパスワード（確認）"
        required
        invalid={isPasswordMismatch || undefined}
        errorText={isPasswordMismatch ? 'パスワードが一致しません' : undefined}
      >
        <PasswordInput
          placeholder="新しいパスワード（確認）"
          value={newPasswordConfirm}
          onChange={e => onNewPasswordConfirmChange(e.target.value)}
          size="lg"
        />
      </Field>

      <Button
        colorPalette="teal"
        size="lg"
        w="full"
        onClick={onSubmit}
        disabled={!isFormValid || isLoading}
        loading={isLoading}
      >
        変更する
      </Button>
    </VStack>
  );
};
